import React, {Component} from 'react'
import PageHeaderWrapper from '../../../components/PageHeaderWrapper'
import {Button, Card, Form, notification, Popconfirm, Tabs, Tooltip} from 'antd'
import {TableComp, FormUtils as GetAllFormFields} from 'sz-react-utils'
import Request from '../../../request'
import styles from '../../Template/all/styles.less'
import moment from 'moment'
import _ from 'lodash'

import {RightsWrapper} from '../../../components/_utils/utils'
const TabPane = Tabs.TabPane

@Form.create()

class AllTestTypes extends Component {
  state = {
    id: '',
    total: 0,
    activeTab: '0',
    refreshChild: false,
    parentRatings: [],
    maritalStatus:[],
  }

  apiRequest = params => {
    return new Promise(async resolve => {
    //   this.setState({exportParams: params})
      let data = await Request.getAllTestTypes({
        ...params,
        regExFilters:[]
      })
      this.setState({total: data.total})
      resolve(data)
    })
  }

  handleSubmit = e => {
    const {form} = this.props
    e.preventDefault()
    form.validateFieldsAndScroll(async (err, valData) => {
      if (!err) {
        let values = _.clone(valData)
        let x = null
        if (this.state.id) {
          values._id = this.state.id
          x = await Request.updateTestTypesDetails(values) //For Updating Data
        } else {
          x = await Request.addTestTypesDetails(values)
        }

        if (!x.error) {
          this.setState({
            id: '',
          })
          notification.success({
            message: this.state.id
              ? `Test Types Updated Successfully`
              : 'Test Types Added successfully'
          })
          if (!this.state.id) {
            form.setFieldsValue({
              testType: '',
              startNumber: '',
              endNumber: '',
              numberStep: ''
            })
            this.setState({activeTab: '0'})
          }
          if (this.table && this.table.current)
            this.table.current.reload()

        } else {
          notification.error({
            message: 'Error Saving',
            description: x.msg
          })
        }
      }
    })
  }

  deleteTestTypesDetails = async data =>{
    this.setState({loading:true})
    await Request.deleteTestTypesDetails(data)
    this.setState({loading:false})
    this.table.current.reload();
    notification.success({
        message: 'Deleted Successfully',
        duration: 20,
        key: `${data._id}-close`
      })
  }
  callback = (value) => {
    if (value) {
      this.chooseTab(value)
    }
  }

  setTestTypesDetailsData(companyDetailId) {
    if(companyDetailId) {
        Request.testTypesDetailByID({id:companyDetailId}).then(
            ({doc,error,message})=>{
                if(!error && doc) {
                    this.setState({
                        id: doc._id,
                        activeTab: '1'
                    })
                this.props.form.setFieldsValue({
                  testType:doc.testType,
                  startNumber:doc.startNumber,
                  endNumber:doc.endNumber,
                  numberStep:doc.numberStep,
                })
                }else {
                    notification.error({
                      message: 'Error Getting Data',
                      description: message
                    })
                  }
            }
        )
    }
  }
  refreshFxn = () => {
    this.setState({refreshChild: !this.state.refreshChild})
  }

//   componentWillMount() {
    
//   }

  async componentDidMount() {
    
  }

  constructor(props) {
    super(props)
    this.table = React.createRef()
  }
  chooseTab(value) {
    this.setState({
        activeTab: value
    })
  }
  render() {
    const {
      form: {getFieldDecorator}
    } = this.props
    const {id} = this.state;

    const inputTypes = {
      fields: [
        {
          label:"Test Types",
          key:"testType",
          required:true
        },
        {
          label:"Start Number",
          key:"startNumber",
          required:true
        },
        {
          label:"End Number",
          key:"endNumber",
          required:true
        },
        {
          label:"Number Steps",
          key:"numberStep",
          required:true
        }
      ]
    };

    const columns = [
      {
        title: 'Test Types',
        key: 'testType',
      },
      {
        title: 'Start Number',
        key: 'startNumber',
      },
      {
        title: 'End Number',
        key: 'endNumber',
      },
      {
        title: 'Number Steps',
        key: 'numberStep',
      },
      {
        title: 'Added By',
        key: 'createdByName',
        dataIndex: 'createdByName',
        render: (text, record) => {
          return (
            <div>
              <div>{record.updatedByUser != null ? record.updatedByUser.name : record.createdByUser != null ? record.createdByUser.name : ""}</div>
              <small>{record.updatedByUser ? moment(record.updatedByUser.time).format('lll') : record.createdByUser ? moment(record.createdByUser.time).format('lll') : '' }</small>
            </div>
          )
        }
      },
      {
        title: 'Action',
        key: 'operation',
        render: (text, record) => (
          <React.Fragment>
            <RightsWrapper myRight={'testTypes.edit'}>
              <Tooltip title="Edit Test Type">
                <Button
                  className={styles.btn}
                  shape="circle"
                  onClick={() => {
                    this.setTestTypesDetailsData(record._id)
                  }}
                  icon="edit"
                />
              </Tooltip>
            </RightsWrapper>
            <RightsWrapper myRight={'testTypes.delete'}>
              <Tooltip title="Delete Test Types">
                <Popconfirm
                  title="Are you sure delete this Test Types?"
                  onConfirm={() => {
                    this.deleteTestTypesDetails({_id: record._id})
                  }}
                  okText="Yes"
                  cancelText="No">
                  <Button
                    className={styles.btn}
                    shape="circle"
                    icon="delete"
                  />
                </Popconfirm>
              </Tooltip>
            </RightsWrapper>
          </React.Fragment>
        )
      }
    ]
    return (
      <PageHeaderWrapper title={` Test Types Details `}>
        <Card bordered={true}>
          <Tabs onChange={this.callback} type="card" activeKey={this.state.activeTab}>
            <TabPane tab={`All Test Types`} key={0}>
              <h2>{`Total : ${this.state.total}`}</h2>
              <TableComp
                ref={this.table}
                columns={columns}
                apiRequest={this.apiRequest}
                extraProps={{scroll: {x: 900}}}
                pagination={{
                  showSizeChanger: true,
                  defaultPageSize: 50,
                  pageSizeOptions: ['10', '20', '50', '100', '1000']
                }}
              />
            </TabPane>
            
            <TabPane tab={(id?'Edit':'Add') + ' Test Types'} key={1}>
              <Form onSubmit={this.handleSubmit} style={{marginTop: 8}}>
                <GetAllFormFields
                  inputSchema={inputTypes}
                  refresh={this.refreshFxn}
                  getFieldDecorator={getFieldDecorator}
                />
                <Button
                  type=""
                  htmlType="submit"
                  style={{
                    marginBottom: 10,
                    marginLeft: '33%',
                    backgroundColor: 'green',
                    color: 'white'
                  }}
                  loading={this.props.loading}>
                  SAVE
                </Button>
                <Button
                  type="primary"
                  style={{marginBottom: 10, marginLeft: '1%'}}
                  loading={this.props.loading}
                  onClick={() => {
                    this.props.form.resetFields()
                  }}>
                  RESET
                </Button>
              </Form>
            </TabPane>
          </Tabs>
        </Card>
      </PageHeaderWrapper>
    );
  }
}

export default AllTestTypes
